import { render, staticRenderFns } from "./prescripQuery.vue?vue&type=template&id=2b936543"
import script from "./prescripQuery.vue?vue&type=script&lang=js"
export * from "./prescripQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports